"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCurrecy = void 0;
var _NumberFormat = require("./NumberFormat.types");
var formatCurrecy = exports.formatCurrecy = function formatCurrecy(props) {
  if (props.value === undefined || !props.currencyId) {
    return props.empty;
  }
  var formatted = (0, _NumberFormat.formatNumber)(props);
  return "".concat(props.forceCode ? '$' : '').concat(formatted, " ").concat(props.currencyId);
};